import React, { useState } from 'react';
import { Input, Button } from "semantic-ui-react";
import { connect } from 'react-redux';
import { resetGrid } from './../redux/actions';

const ConfigurationBox = (props) => {
  const [gridSize, setGridSize] = useState('');
  const [streak, setStreak] = useState('');
  const grid = [];
  const resetGame = () => {
    if (!gridSize || !streak) {
      alert('Enter grid size and steak')
      return;
    }
    if (streak > gridSize) {
      alert('Streak cannot be greater than grid')
      return;
    }
    for ( var i = 0; i < gridSize; i++ ) {
      grid[i] =[];
      for ( var j = 0; j < gridSize; j++ ) {
         grid[i][j] = null;
      }
    }
    props.resetGrid({gridSize, streak, grid})

  };
  return (
    <div>
      <Input className='u-margin' placeholder='n * n grid' value={gridSize} onChange={(event,element) => setGridSize(parseInt(element.value, 10))} />
        with
      <Input className='u-margin' placeholder='M streak' value={streak} onChange={(event,element) => setStreak(parseInt(element.value, 10))} />
      <Button className='u-margin' onClick={resetGame}>Start or Reset Game</Button>
    </div>
  )
  
};

const mapStateToProps = (state /*, ownProps*/) => {
  console.log(state.gridSize, state.streak, 'streak')
  return {
    gridSize: state.gridSize,
    streak: state.streak
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetGrid: (payload) => { dispatch(resetGrid(payload)); }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationBox);